"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandedAvatarContainer = exports.BlurBackgroundDiv = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var BrandedAvatarContainer = exports.BrandedAvatarContainer = _styledComponents["default"].div(function (props) {
  return "\n    position: relative;\n    height: ".concat(props.height, ";\n    width: ").concat(props.width, ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #333649;\n  ");
});
var BlurBackgroundDiv = exports.BlurBackgroundDiv = _styledComponents["default"].div(function (props) {
  return "\n    position: absolute;\n    height: ".concat(props.height, ";\n    width: ").concat(props.width, ";\n    background-image: url(").concat(props.user.photo, ");\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    filter: ").concat(props.user.photo ? 'blur(10px)' : 'blur(0px)', ";\n    mix-blend-mode: screen;\n    opacity: 40%;\n  ");
});